import { render, staticRenderFns } from "./FilterItemBox.vue?vue&type=template&id=d6caa64a&"
import script from "./FilterItemBox.vue?vue&type=script&lang=js&"
export * from "./FilterItemBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports